import {features} from "@/app/Features";

export default function(perm, arg1, options) {
    if (options === undefined) options = arg1;
    if (features[perm](arg1)) return options.fn(this);
    return options.inverse(this);
}
